import PropTypes from 'prop-types'
import React from 'react'
import { TableRow } from '../TableSections/TableBody'

export default function PagedBody({
  page,
  prepareRow,
  getTableBodyProps,
  isSelectable,
}) {
  return (
    <tbody {...getTableBodyProps()}>
      {page.map((row) => {
        prepareRow(row)
        return <TableRow row={row} isSelectable={isSelectable} key={row.id} />
      })}
    </tbody>
  )
}

PagedBody.propTypes = {
  getTableBodyProps: PropTypes.func,
  isSelectable: PropTypes.any,
  page: PropTypes.array,
  prepareRow: PropTypes.func,
  row: PropTypes.object,
}
